import React, { useContext } from "react";
import UserContext from "../../contexts/UserContext";
import Header from "../Navigation/Header";

function Help() {
	const userCtx = useContext(UserContext);

	return (
		<>
			<Header />
			<div id="page">
				<div className="page-inner">
					<div id="main">
						{(userCtx && userCtx.loggedInUserId) ?
							<div style={{ display: 'block', margin: '40px auto', textAlign: 'center' }}>
								<iframe allowfullscreen="" class="sproutvideo-player" frameborder="0" height="354" src="//videos.sproutvideo.com/embed/a49ad8b41d1be1c02c/371a6ae87945b9cd" width="630"></iframe>
							</div>
							: <div></div>
						}
					</div>
				</div>
			</div>
		</>
	);
}
export default Help;
